import { IOfferState } from '../../redux/reducers';

export const isAreaPartsEnabled = ({ areaParts }: IOfferState) => Array.isArray(areaParts) && areaParts.length >= 0;
